import React, { useEffect, useState } from "react";
import "./share.css";
import Header from "../../../Layout/Header/Header";
import Icons from "../../../../../Config/Images";
import Footer from "../../../Layout/Footer/Footer";
import { useDispatch } from "react-redux";
import { latestWalletTransactionUrl } from "../../../../../Store/Action/walletAction";
import { getLoggedInUserDetailsAPI } from "../../../../../Store/Action/UserAction";
import {
  getMilestonesAPI,
  getReferralsAPI,
  getTransactionTypeAPI,
} from "../../../../../Store/Action/rewardPointsAction";

const Share = () => {
  const dispatch = useDispatch();

  const [referEarnData, setReferEarnData] = useState([]);
  const [transactionTypeId, setTransactionTytpeId] = useState(null);
  const [referalUsage, setReferalUsage] = useState({});


  // useEffect(() => {
  //   dispatch(
  //     latestWalletTransactionUrl({}, (result) => {
  //       setReferEarnData(result);
  //     })
  //   );
  // }, [dispatch]);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setReferEarnData(result?.data);
      })
    );
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(
  //     getTransactionTypeAPI({}, (result) => {
  //       if (result?.status && Array.isArray(result.data)) {
  //         // ✅ Using find (better since you only need one match)
  //         const referAndEarn = result.data.find(
  //           (item) => item.transaction_type_name === "refer&earn"
  //         );

  //         setTransactionTytpeId(referAndEarn?.transaction_type_id);
  //       }
  //     })
  //   );
  // }, [dispatch]);

  // useEffect(() => {
  //   if (transactionTypeId) {
  //     const params = {
  //       milestone_id: transactionTypeId,
  //     };
  //     dispatch(
  //       getMilestonesAPI(params, (result) => {
  //         setReferalUsage(result?.data?.[0]);
  //       })
  //     );
  //   }
  // }, [transactionTypeId, dispatch]);

  useEffect(()=> {
    dispatch(getReferralsAPI({},(result)=> {
      setReferalUsage(result?.data?.[0])
    }))
  },[])
  return (
    <>
      <Header />
      <div className="share-main-div">
        <div className="share-header">
          <p className="share-header-para">Refer & Earn</p>
        </div>

        <div className="divider" />

        <div className="share-lower-div">
          <div className="refer-earn-content">
            <div className="refer-earn-boxes refer-earn-div1">
              <div className="box">
                <p className="para-1">Referral Code Usage</p>
                <p className="para-2">
                  {referalUsage?.total_referrer_count || "-"}
                </p>
              </div>
              <div className="box">
                <p className="para-1">Earnings from Referral</p>
                <p className="para-2">₹{referalUsage?.total_referrer_amount}</p>
              </div>
            </div>
            <div className="refer-earn-div2">
              <p>
                Invite a friend and earn <span> ₹100 </span> in your wallet for
                every successful registration.
              </p>
            </div>
            <div className="refer-earn-div3">
              <div className="share-btn">
                {" "}
                <p>Share</p>
                <img src={Icons.refer_earn_share_icon} alt="" />
              </div>
            </div>
            <div className="refer-earn-div4">
              <p>
                Referral Code :{" "}
                {referEarnData?.map((e) => e.user_referral_code)}
              </p>
            </div>
            <div className="refer-earn-div5">
              <div className="refer-earn-header">
                <p>How to Register</p>
              </div>

              <div className="refer-earn-steps">
                <p>
                  <span>Step 1 </span>: Tell your friends about Zabali and
                  register them on the app.
                </p>
                <p>
                  <span>Step 2 </span>: Enter Referral Code while creating an
                  account.
                </p>
                <p>
                  <span>Step 3 </span>: Check your wallet to see Rs 100 credited
                  to your account.
                </p>
              </div>
            </div>
          </div>
          <div className="refer-earn-image">
            <img src={Icons.refer_earn_img} alt="" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Share;
